class VwKargokuryetakip1DTO {
    id: number = 0;
    organizasyonId?: number = null;
    organizasyonAdi?: string = "";
    ordergrup?: string = "";
    kargokuryekurumId?: number = null;
    kurumAdi?: string = "";
    kargotakipno?: number = null;
    kargokuryeadi?: string = "";
    kargokuryetarih?: string = null;
    aciklama?: string = "";
    numuneSayi?: number = null;
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    onaylamaTarihi?: string = null;
    onaylayanKullanici?: number = null;
    fkIptalneden?: number = null;
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
}
export default VwKargokuryetakip1DTO;